import React from "react";
import {MobileOutlined, SlidersOutlined} from "@ant-design/icons";
import {Col, Layout, Row} from "antd";
import {Link} from "react-router-dom";
import {ArrowBackOutlined} from "@mui/icons-material";
import cookie from "react-cookies";
import {isTrue} from "../../utils/utils";

const {Content} = Layout;

function C240Settings(props) {

    const deviceId = props.match.params.id;
    const is_superuser = isTrue(cookie.load("superuser"))

    return (
        <Content className={"c240-settings-container full-parent"} style={{padding: '24px'}}>
            <Row>
                <Row style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    height: '50px',
                    backgroundColor: 'rgba(255, 255, 255, 0.9)',
                    padding: '30px',
                    boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
                    zIndex: '1000',
                }} className={"settings-header"}>
                    <Link to={"/c240_control_panel/" + deviceId}>
                        <ArrowBackOutlined style={{fontSize: "32px"}}/>
                    </Link>
                    <div className={"flex-center full-width"}>
                        <h1 style={{fontSize: "38px", textAlign: "center", margin: 0}}>Scanner Settings</h1>
                    </div>
                </Row>

                <Row className={"full-width"} style={{marginTop: "100px"}}>
                    <Col span={3} offset={is_superuser ? 8 : 11}>
                        <Link to={"/c240_stage_cleanup/" + props.match.params.id + "/"} className="scanner-user-controls">
                            <Row className={"flex-center"} style={{color: "#0499e8"}}><MobileOutlined
                                className="scanner-main-control-icon"/></Row>
                            <Row className={"flex-center"}>Stage Maintenance</Row>
                        </Link>
                    </Col>
                    {is_superuser ?
                        <Col span={3} offset={2}>
                            <Link className="scanner-user-controls" to={"/manualmode/" + deviceId + "/"}>
                                <Row className={"flex-center"} style={{color: "#d63031"}}><SlidersOutlined
                                    className="scanner-main-control-icon"/></Row>
                                <Row className={"flex-center"}>Manual Mode</Row>
                            </Link>
                        </Col> : null}
                </Row>
            </Row>
        </Content>
    );
}

export default C240Settings;